export default "__VITE_ASSET__Diu3ytT___"